import { CourseData, CourseLesson } from '../types/Tables';

type Translatable = {
  lang?: string;
  translations?: Array<Record<string, any>>;
  [key: string]: any;
};

/**
 * Generic translation helper. Returns the requested `element` from the
 * translation matching `lang` if available, otherwise falls back to the
 * original `component` value. `defaultLang` (default: 'en') will read
 * directly from the `component` without searching `translations`.
 */
export const getTranslate = <T extends Translatable>(
  element: 'name' | 'title' | 'description',
  lang: string,
  component: T | CourseData | CourseLesson,
  defaultLang = 'en',
): string | undefined => {
  const readProp = (obj?: any) => (obj && obj[element] !== undefined ? obj[element] : undefined);

  if (lang === defaultLang) {
    return readProp(component as any);
  }

  const translation = (component as any).translations?.find((t: any) => t?.lang === lang);

  return readProp(translation) ?? readProp(component as any);
};
